import $ from "jquery";
import 'slick-carousel';

const testimonials = function () {
  const selector = '.js-testimonials-slider';

  $(selector).slick({
    lazyLoad: 'ondemand',
    'dots': true,
    'arrows': true,
    'infinite': true,
    'slidesToShow': 1,
    appendDots: '.b-testimonials .slick-append-dots',
    nextArrow: '<button type="button" class="slick__next material-icons">keyboard_arrow_right</button>',
    prevArrow: '<button type="button" class="slick__prev material-icons">keyboard_arrow_left</button>',
  });
};

export default testimonials;


